module.exports = __webpack_public_path__ + "static/media/logoEN.83ce90f4.svg";